import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'secondsToTime'
})
export class SecondsToTimePipe implements PipeTransform {
  transform(value: number): string {
    const minutes = Math.floor(value / 60);
    const seconds = Math.ceil(value % 60);

    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;

  }
}
